export { default } from './StackedBarChart.js';
